import React from 'react'
import { Trans } from '@lingui/react/macro'

import { XStack, YStack, useMedia } from 'tamagui'

import { Text } from '@newComponents/Text'
import { Link } from '@newComponents/Link'
import { GuildPrimaryPhoto } from '@newComponents/Guild/GuildPrimaryPhoto'

import { selectMediaValue } from './utils'
import { UnauthenticatedHomeScreen_query$data } from './__generated__/UnauthenticatedHomeScreen_query.graphql'

export function FeaturedGuildsSection({
  rankedGuilds,
}: {
  rankedGuilds: UnauthenticatedHomeScreen_query$data['rankedGuilds']
}) {
  const media = useMedia()

  return (
    <YStack gap='$6'>
      <Text size='$6' fontWeight='$7' textAlign='center'>
        <Trans>Loved by communities everywhere</Trans>
      </Text>

      <XStack gap='$10' justifyContent='center'>
        {rankedGuilds?.edges
          .slice(0, selectMediaValue(media, [3, 4, 4, 5]))
          .map(({ node, cursor }) => {
            return (
              <Link
                href={`/${node.slugId}`}
                key={cursor}
                textDecorationLine='none'
                hoverStyle={{ textDecorationLine: 'none' }}
              >
                <YStack gap='$2' alignItems='center'>
                  <GuildPrimaryPhoto guild={node} size='$15' />

                  <Text size='$4' textAlign='center' maxWidth='$20'>
                    {node.name}{' '}
                    {node.type === 'NETWORK' && <Trans>Network</Trans>}
                  </Text>
                </YStack>
              </Link>
            )
          })}
      </XStack>
    </YStack>
  )
}
